import { Client } from 'api/typegen/client/get';
import getClientApiCall from 'api/calls/getClientApiCall';
import useAuth from './useAuth';
import useProtectedQuery from './useProtectedQuery';

const useClientQuery = (enabled = false) => {
  const { token } = useAuth();
  return useProtectedQuery<Client>(
    ['getClientApiCall', token],
    getClientApiCall,
    {
      enabled,
    },
  );
};

export default useClientQuery;
